<header class="sticky-top w-100 header">
  <nav class="container navbar navbar-expand-lg navbar-dark">
    <a class="navbar-brand" [routerLink]="[path.home]">
      <svg
        width="76"
        height="38"
        viewBox="0 0 76 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.4012 31.563C9.4012 33.574 8.85527 35.0952 7.76568 36.1252C6.67584 37.1541 5.07528 37.669 2.96375 37.669H0V25.685H3.34501C5.32127 25.685 6.82404 26.1854 7.85511 27.1863C8.88643 28.1864 9.4012 29.6448 9.4012 31.563V31.563ZM72.9794 11.5804H71.7903V17.5934H72.9794V11.5804ZM69.7281 10.7939H68.539V17.5924H69.7281V10.7939ZM66.317 8.48985H65.1279V14.2107H66.317V8.48985ZM62.9077 6.95441H61.7175V14.2097H62.9077V6.95441V6.95441ZM59.3384 5.56753H58.1488V14.2107H59.3384V5.56753V5.56753ZM56.0066 3.99605H54.8172V17.5934H56.0066V3.99605V3.99605ZM52.5967 2.62143H51.4068V17.5934H52.5967V2.62143V2.62143ZM49.1063 1.14703H47.9172V17.5934H49.1063V1.14703V1.14703ZM45.3788 0.165894H44.1899V17.5934H45.3788V0.165894V0.165894ZM41.8093 0.165894H40.6201V17.5934H41.8093V0.165894V0.165894ZM38.3196 0.165894H37.1305V17.5934H38.3196V0.165894V0.165894ZM34.6716 0.755261H33.4825V17.5934H34.6716V0.755261V0.755261ZM31.1817 2.62143H29.9928V17.5934H31.1817V2.62143V2.62143ZM27.5329 4.8801H26.3428V17.5934H27.5329V4.8801ZM23.9632 7.13951H22.7741V17.5934H23.9632V7.13951V7.13951ZM20.5531 9.20205H19.3637V17.5934H20.5531V9.20205V9.20205ZM17.0642 9.20205H15.875V14.2107H17.0642V9.20205ZM13.494 9.20205H12.3046V14.2107H13.494V9.20205ZM10.1629 9.68036H8.97374V14.2107H10.1629V9.68036V9.68036ZM6.59469 11.2636H5.4058V17.5924H6.59469V11.2636ZM3.10477 13.1295H1.91461V17.5934H3.10477V13.1295ZM75.3816 37.669L75.1706 36.26H75.1017C74.6388 36.8329 74.1626 37.2387 73.6747 37.4767C73.186 37.7143 72.6096 37.8339 71.9424 37.8339C71.039 37.8339 70.336 37.6099 69.8331 37.1607C69.331 36.7133 69.0797 36.0933 69.0797 35.3C69.0797 34.4316 69.4531 33.7579 70.202 33.2759C70.9506 32.7947 72.0328 32.5416 73.4497 32.5142L75.2035 32.4639V31.8738C75.2035 31.0275 75.0257 30.3879 74.6695 29.9564C74.3136 29.5254 73.7418 29.3092 72.9511 29.3092C72.0979 29.3092 71.2143 29.5382 70.2997 29.9976L69.9859 29.292C70.9964 28.8336 71.9966 28.6031 72.9846 28.6031C73.9954 28.6031 74.7508 28.8576 75.2496 29.3658C75.7492 29.8738 76 30.6662 76 31.7439V37.669H75.3816V37.669ZM71.993 37.095C72.9762 37.095 73.7504 36.8236 74.3179 36.2796C74.8858 35.7354 75.1706 34.9808 75.1706 34.0138V33.1369L73.5599 33.2026C72.2676 33.2614 71.345 33.4578 70.7948 33.7885C70.2435 34.119 69.9686 34.6348 69.9686 35.3333C69.9686 35.8901 70.1452 36.3233 70.4986 36.6331C70.851 36.9406 71.3498 37.095 71.993 37.095V37.095ZM67.28 37.1122C67.8102 37.1122 68.2741 37.0678 68.669 36.9815V37.6376C68.2619 37.7682 67.793 37.833 67.2618 37.833C66.4496 37.833 65.8497 37.6236 65.4626 37.2027C65.076 36.7807 64.883 36.12 64.883 35.2188V29.4646H63.5188V28.99L64.883 28.62L65.3055 26.6031H65.7385V28.7593H68.4395V29.4646H65.7385V35.1036C65.7385 35.7868 65.8624 36.2924 66.1106 36.6204C66.3584 36.9484 66.7488 37.1122 67.28 37.1122ZM56.2121 28.7603V34.5304C56.2121 35.4257 56.4072 36.0774 56.7968 36.4853C57.1865 36.8928 57.7909 37.095 58.6092 37.095C59.7048 37.095 60.5107 36.8285 61.0277 36.2924C61.5435 35.7569 61.8029 34.8859 61.8029 33.6775V28.7603H62.6326V37.669H61.9202L61.7685 36.4392H61.7181C61.12 37.3694 60.0552 37.8339 58.5256 37.8339C56.4303 37.8339 55.3825 36.7494 55.3825 34.5784V28.7603H56.2121ZM52.7521 37.669L52.5406 36.26H52.4719C52.0093 36.8329 51.5328 37.2387 51.0449 37.4767C50.556 37.7143 49.9799 37.8339 49.3126 37.8339C48.409 37.8339 47.706 37.6099 47.2033 37.1607C46.7015 36.7133 46.4502 36.0933 46.4502 35.3C46.4502 34.4316 46.8231 33.7579 47.5722 33.2759C48.3208 32.7947 49.403 32.5416 50.8197 32.5142L52.574 32.4639V31.8738C52.574 31.0275 52.3959 30.3879 52.0397 29.9564C51.6838 29.5254 51.112 29.3092 50.3214 29.3092C49.4684 29.3092 48.5845 29.5382 47.67 29.9976L47.3564 29.292C48.3667 28.8336 49.3668 28.6031 50.3548 28.6031C51.3656 28.6031 52.1216 28.8576 52.6201 29.3658C53.1199 29.8738 53.3702 30.6662 53.3702 31.7439V37.669H52.7521ZM49.3633 37.095C50.3465 37.095 51.1206 36.8236 51.6886 36.2796C52.2561 35.7354 52.5406 34.9808 52.5406 34.0138V33.1369L50.9301 33.2026C49.6384 33.2614 48.7157 33.4578 48.165 33.7885C47.6137 34.119 47.3394 34.6348 47.3394 35.3333C47.3394 35.8901 47.5155 36.3233 47.8689 36.6331C48.2212 36.9406 48.7201 37.095 49.3633 37.095V37.095ZM42.1202 37.6699H35.5482V37.1524L41.0106 29.4811H35.9455V28.7603H42.103V29.2751L36.6062 36.9484H42.1202V37.6699V37.6699ZM30.0235 37.669L29.812 36.26H29.7434C29.2805 36.8329 28.8043 37.2387 28.3163 37.4767C27.8277 37.7143 27.2513 37.8339 26.584 37.8339C25.6804 37.8339 24.9774 37.6099 24.475 37.1607C23.9727 36.7133 23.7211 36.0933 23.7211 35.3C23.7211 34.4316 24.0948 33.7579 24.8439 33.2759C25.5922 32.7947 26.6747 32.5416 28.0911 32.5142L29.8452 32.4639V31.8738C29.8452 31.0275 29.6674 30.3879 29.3112 29.9564C28.955 29.5254 28.3835 29.3092 27.5926 29.3092C26.7393 29.3092 25.856 29.5382 24.9412 29.9976L24.6275 29.292C25.6381 28.8336 26.6383 28.6031 27.6263 28.6031C28.6371 28.6031 29.3922 28.8576 29.8913 29.3658C30.3911 29.8738 30.6417 30.6662 30.6417 31.7439V37.669H30.0235V37.669ZM26.6347 37.095C27.6176 37.095 28.3923 36.8236 28.9598 36.2796C29.5273 35.7354 29.812 34.9808 29.812 34.0138V33.1369L28.2016 33.2026C26.9096 33.2614 25.9867 33.4578 25.4364 33.7885C24.8854 34.119 24.6103 34.6348 24.6103 35.3333C24.6103 35.8901 24.7869 36.3233 25.1403 36.6331C25.4924 36.9406 25.9915 37.095 26.6347 37.095V37.095ZM21.9214 37.1122C22.4519 37.1122 22.9155 37.0678 23.3107 36.9815V37.6376C22.9036 37.7682 22.4349 37.833 21.9035 37.833C21.091 37.833 20.4911 37.6236 20.104 37.2027C19.7177 36.7807 19.5244 36.12 19.5244 35.2188V29.4646H18.1605V28.99L19.5244 28.62L19.9472 26.6031H20.3799V28.7593H23.0812V29.4646H20.3799V35.1036C20.3799 35.7868 20.504 36.2924 20.7526 36.6204C20.9998 36.9484 21.3902 37.1122 21.9214 37.1122V37.1122ZM16.7583 37.669L16.547 36.26H16.4781C16.0152 36.8329 15.539 37.2387 15.051 37.4767C14.5624 37.7143 13.986 37.8339 13.319 37.8339C12.4154 37.8339 11.7124 37.6099 11.2097 37.1607C10.7074 36.7133 10.4563 36.0933 10.4563 35.3C10.4563 34.4316 10.8295 33.7579 11.5786 33.2759C12.3269 32.7947 13.4094 32.5416 14.8261 32.5142L16.5799 32.4639V31.8738C16.5799 31.0275 16.4023 30.3879 16.0461 29.9564C15.6902 29.5254 15.1182 29.3092 14.3275 29.3092C13.4743 29.3092 12.5907 29.5382 11.6764 29.9976L11.3625 29.292C12.3728 28.8336 13.373 28.6031 14.361 28.6031C15.372 28.6031 16.1275 28.8576 16.6263 29.3658C17.1258 29.8738 17.3764 30.6662 17.3764 31.7439V37.669H16.7583V37.669ZM13.3697 37.095C14.3526 37.095 15.127 36.8236 15.6945 36.2796C16.2625 35.7354 16.547 34.9808 16.547 34.0138V33.1369L14.9363 33.2026C13.644 33.2614 12.7214 33.4578 12.1711 33.7885C11.6201 34.119 11.3453 34.6348 11.3453 35.3333C11.3453 35.8901 11.5219 36.3233 11.875 36.6331C12.2274 36.9406 12.7262 37.095 13.3697 37.095V37.095ZM8.46057 31.5963C8.46057 29.8799 8.01065 28.5894 7.10955 27.7225C6.2092 26.8573 4.88655 26.4236 3.14133 26.4236H0.86336V36.932H2.91283C6.61175 36.932 8.46057 35.1521 8.46057 31.5963Z"
          fill="white"
        />
      </svg>
    </a>
    <!-- Signed-in vehicle. Outside the collapse so a driver can sign out
         without opening the menu — that is the whole point of it. Gated on
         showMemu with everything else: on /tag the page already owns this
         state, and a badge there could sign the driver out behind its back. -->
    @if (showMemu() && vehicleSession() && vehiclePlate()) {
      <div class="vehicle-badge-wrapper">
        <button
          type="button"
          class="vehicle-badge"
          (click)="onToggleVehiclePanel()"
        >
          <i class="icon icon-cars"></i>
          <span class="vehicle-badge-plate">{{ vehiclePlate() }}</span>
        </button>

        @if (isVehiclePanelOpen()) {
          <div class="vehicle-panel">
            <span class="vehicle-panel-label" i18n
              >Jste přihlášeni k vozidlu</span
            >
            <span class="vehicle-panel-plate">{{ vehiclePlate() }}</span>
            <span class="vehicle-panel-label" i18n
              >Od {{ vehicleSessionStartedAt() }}</span
            >
            <button
              type="button"
              class="vehicle-panel-action"
              [disabled]="isSigningOutVehicle()"
              (click)="onSignOutVehicle()"
              i18n
            >
              Odhlásit se z vozidla
            </button>
          </div>
        }
      </div>
    }

    @if (showMemu()) {
      <label
        class="navbar-toggler menu-button-container"
        [class.menu-button-container-opened]="!isCollapsed"
        (click)="isCollapsed = !isCollapsed"
      >
        <div class="menu-button"></div>
      </label>
      <div class="navbar-collapse collapse" [collapse]="isCollapsed">
        <ul class="navbar-nav mr-auto">
          @if (loggedUserHasRight('viewMap')) {
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="'/' + path.map"
                [routerLinkActive]="['is-active']"
                (click)="isCollapsed = true"
                i18n
                >Mapa</a
              >
            </li>
          }
          @if (loggedUserHasRight('viewLogbook')) {
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="'/' + path.routesBook"
                [routerLinkActive]="['is-active']"
                (click)="isCollapsed = true"
                i18n
                >Kniha jízd</a
              >
            </li>
          }
          @if (loggedUserHasRight('viewGeneralOverview')) {
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="'/' + path.overview"
                [routerLinkActive]="['is-active']"
                (click)="isCollapsed = true"
                i18n
                >Celkový přehled</a
              >
            </li>
          }
          @if (loggedUserHasRight('viewFleet')) {
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="'/' + path.vehiclePark"
                [routerLinkActive]="['is-active']"
                (click)="isCollapsed = true"
                i18n
                >Vozový park</a
              >
            </li>
          }
          @if (loggedUserHasRight('viewStations')) {
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="'/' + path.stations"
                [routerLinkActive]="['is-active']"
                (click)="isCollapsed = true"
                i18n
                >Čerpací stanice</a
              >
            </li>
          }
          <li class="nav-item">
            <a
              class="nav-link dropdown-toggle"
              [routerLinkActive]="['is-active-dropdown-toggle']"
            >
              <span class="mobile-menu-divider">Sestavy</span>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                @if (loggedUserHasRight('viewRefueling')) {
                  <a
                    class="dropdown-item"
                    [routerLink]="
                      '/' + reportsPath.basePath + '/' + reportsPath.refueling
                    "
                    [routerLinkActive]="['is-active']"
                    (click)="isCollapsed = true"
                    i18n
                    >Tankování</a
                  >
                }
                @if (loggedUserHasRight('viewTrips')) {
                  <a
                    class="dropdown-item"
                    [routerLink]="
                      '/' +
                      reportsPath.basePath +
                      '/' +
                      reportsPath.drivingProgress
                    "
                    [routerLinkActive]="['is-active']"
                    (click)="isCollapsed = true"
                    i18n
                    >Provozní údaje</a
                  >
                }
                <!-- <a
                              *ngIf="loggedUserHasRight('viewCAN')"
                              class="dropdown-item"
                  [routerLink]="
                    '/' + reportsPath.basePath + '/' + reportsPath.canOverview
                  "
                              [routerLinkActive]="['is-active']"
                              (click)="isCollapsed = true"
                              i18n
                              >CAN přehled</a
                              > -->
                @if (loggedUserHasRight('viewWorkingHours')) {
                  <a
                    class="dropdown-item"
                    [routerLink]="
                      '/' +
                      reportsPath.basePath +
                      '/' +
                      reportsPath.workingHours
                    "
                    [routerLinkActive]="['is-active']"
                    (click)="isCollapsed = true"
                    i18n
                    >Pracovní doba</a
                  >
                }
                @if (loggedUserHasRight('viewOperators')) {
                  <a
                    class="dropdown-item"
                    [routerLink]="
                      '/' +
                      reportsPath.basePath +
                      '/' +
                      reportsPath.operatorsRegistry
                    "
                    [routerLinkActive]="['is-active']"
                    (click)="isCollapsed = true"
                    i18n
                    >Řidiči a ostatní</a
                  >
                }
                @if (loggedUserHasRight('viewAetr')) {
                  <a
                    class="dropdown-item"
                    [routerLink]="
                      '/' + reportsPath.basePath + '/' + reportsPath.aetr
                    "
                    [routerLinkActive]="['is-active']"
                    (click)="isCollapsed = true"
                    i18n
                    >AETR - režim řidičů</a
                  >
                }
                @if (loggedUserHasRight('viewTemperatures')) {
                  <a
                    class="dropdown-item"
                    [routerLink]="
                      '/' +
                      reportsPath.basePath +
                      '/' +
                      reportsPath.temperatures
                    "
                    [routerLinkActive]="['is-active']"
                    (click)="isCollapsed = true"
                    i18n
                    >Teploty</a
                  >
                }
              </div>
            </a>
          </li>
        </ul>
      </div>
      <div class="navbar-collapse collapse" [collapse]="isCollapsed">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item nav-item-right active">
            <a class="nav-link dropdown-toggle">
              <span class="mobile-menu-divider"
                ><app-svg-icon
                  [icon]="'person'"
                  fill="white"
                  [width]="37"
                  [height]="37"
                ></app-svg-icon
              ></span>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" (click)="onClickSignOut()" i18n
                  >Odhlásit se</a
                >
              </div>
            </a>
          </li>
        </ul>
      </div>
    }
  </nav>
</header>
<img
  src="assets/icons/logo-black.svg"
  class="print-visible"
  style="width: 146px; height: auto; position: absolute; left: 40px; top: 40px"
/>
